import { motion } from "framer-motion";
import dilIcon from "../../assets/dil.png";

const LoadingScreen = () => {
  return (
    <div className="fixed inset-0 z-[9999] overflow-hidden bg-white flex items-center justify-center">

      <div className="relative flex flex-col items-center px-6 text-center">

        {/* Icon */}

        <motion.div
          animate={{
            y: [0, -6, 0],
            rotate: [0, 2, -2, 0],
          }}
          transition={{
            duration: 2,
            repeat: Infinity,
          }}
        >
          <img
            src={dilIcon}
            alt="Aishcraft"
            className="w-[34px] h-[34px] object-contain"
          />
        </motion.div>

        {/* Logo */}

        <motion.h1
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
          className="mt-4 font-['Dancing_Script']
          text-2xl sm:text-3xl md:text-5xl
          text-black"
        >
          Aishcraft
        </motion.h1>

        {/* Divider */}

        <div className="flex items-center gap-3 mt-5">

          <div className="w-14 md:w-20 h-px bg-gray-300"/>

          <div className="w-2 h-2 rounded-full bg-black"/>

          <div className="w-14 md:w-20 h-px bg-gray-300"/>

        </div>

        {/* Tagline */}

        <p
          className="
          mt-5
          text-lg
          sm:text-sm
          tracking-[4px]
          md:tracking-[5px]
          uppercase
          text-gray-600"
        >
          Crafting Your Stories
        </p>

        {/* Loader */}

        <div
          className="
          relative
          mt-8
          h-[4px]
          w-56
          sm:w-72
          md:w-96
          bg-gray-200
          rounded-full
          overflow-hidden"
        >
          <motion.div
            className="absolute top-0 left-0 h-full bg-black rounded-full"
            initial={{ x: "-100%" }}
            animate={{ x: "250%" }}
            transition={{
              duration: 2.5,
              repeat: Infinity,
              ease: "easeInOut",
            }}
            style={{
              width: "35%",
            }}
          />
        </div>

        {/* Loading */}

        <motion.p
          animate={{
            opacity: [0.4, 1, 0.4],
          }}
          transition={{
            duration: 1.5,
            repeat: Infinity,
          }}
          className="
          mt-6
          text-[11px]
          tracking-[6px]
          text-gray-500"
        >
          LOADING...
        </motion.p>

      </div>

    </div>
  );
};

export default LoadingScreen;